import { useTimes } from './useTimes';
import { useClickGenerate } from './useClickGenerate';
import { useCalenderSettings } from './useCalenderSettings';
import { useLocationStore } from '../state/storeLocation';
import PrayTimes from '../libs/PrayTimes.js';

export const useGenerateCalender = () => {
	const prayerTime = new PrayTimes();
	const { appendDataGenerate } = useClickGenerate();
	const { timePrayer } = useTimes();
	const DataTable: object[] = [];
	const { settingsPrayer } = useCalenderSettings();
	const {customLocationSelected} = useLocationStore( ( state ) => state );
	



	const GenerateCalender = async () => {
		const currentDate = new Date();
		const currentyear = currentDate.getFullYear();
		// const currentMonth = currentDate.getMonth();
		const startDate = new Date( currentyear, Number( 0 ) );
		const endDate = new Date( currentyear, Number( 13 ) );

		await settingsPrayer( prayerTime );

		while ( startDate < endDate ) {
			const times = prayerTime.getTimes(
				startDate,
				[ customLocationSelected.lat, customLocationSelected.lng ],
				'auto',
				'auto',
				'24h'
			);
			await timePrayer( times, startDate );

			DataTable.push( times );
			startDate.setDate( startDate.getDate() + 1 );
		}
		if ( DataTable?.length ) {
			appendDataGenerate( DataTable );
		}
	};

	return { GenerateCalender };
};
